
import { Component, OnInit, ViewChild } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatTableModule } from '@angular/material/table';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { PermanentdelegationService } from '../../../../../services/PermanentDelegation/permanentdelegation.service';
import { GroupedData, GroupedDataItem, Permanentdelegation } from '../../../../../interface/permanentdelegation/permanentdelegation';
import { DataService } from '../../../../../shared/data.service';
import { Router } from '@angular/router';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { SharedServices } from '../../../../../shared/services/shared.services';

@Component({
  selector: 'app-multipledelegation',
  imports: [CommonModule, FormsModule, ReactiveFormsModule, MatTableModule, MatProgressSpinner, MatPaginatorModule, MatTooltipModule],
  templateUrl: './multipledelegation.component.html',
  styleUrls: ['./multipledelegation.component.css']
})
export class MultipledelegationComponent implements OnInit {
  form: FormGroup;
  Doacategory: Permanentdelegation[] = [];
  filteredData: GroupedDataItem[] = [];
  data: Permanentdelegation[] = [];
  processedData: GroupedDataItem[] = [];
  directreport: Permanentdelegation[] = [];
  selectedCategory: string = 'all';
  cai: string = '';
  employeeNo: string = ' ';
  emailAddress: string = ' ';
  loggeduser: string = '';
  uniqueCais: string[] = [];
  dropdownData: any[] = [];
  clickedCells: { [key: number]: { [key: number]: { dropdownData: any[], selectedOption: any } } } = {};
  showDropdown: { [key: number]: { [key: number]: boolean } } = {}; // New property
  selectedRowData: any[] = [];
  updatedRow: any = {};
  loggeduserdetails: Permanentdelegation[] = [];
  dataSource = new MatTableDataSource<GroupedDataItem>(this.filteredData);
  anyAmountSelected: boolean = false;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  displayedColumns: string[] = ['typeName', 'loggeduser', ...this.uniqueCais];
  showFields: boolean = false;

  constructor(
    private permanentdelegationService: PermanentdelegationService,
    private http: HttpClient,
    private fb: FormBuilder,
    private router: Router,
    private dataservice: DataService,  
    private sharedService: SharedServices
    
  ) {
    this.form = this.fb.group({
      searchbydoatype: [''],
      Doacategory: [''],
      directreport: ['']
    });
  }

  ngOnInit(): void {
    this.loggeduserdetails = history.state.data;
    if (this.loggeduserdetails) {
      this.cai = this.loggeduserdetails[0].cai;
      this.loggeduser = this.loggeduserdetails[0].preferredName;
      this.employeeNo = this.loggeduserdetails[0].employeeNo;
      this.emailAddress = this.loggeduserdetails[0].emailAddress;
    }
    this.selectedCategory = 'ALL';
    this.fetchCategories(this.employeeNo);
    this.showFields = true;
    this.getdirectreport(this.emailAddress);
    this.form.get('searchbydoatype')?.valueChanges.subscribe(value => this.filterData(value));
    this.dataSource.paginator = this.paginator;
  }

  fetchCategories(employeeNo: string): void {
    this.permanentdelegationService.getCategories(employeeNo).subscribe((data: Permanentdelegation[]) => {
      this.Doacategory = data;
      if (this.Doacategory.length > 0 && this.selectedCategory !== 'ALL') {
        this.selectedCategory = this.Doacategory[0].catName;
      }
      this.showFields = true;
      this.fetchMultipleData(this.emailAddress, this.selectedCategory);
    },
    (error: any) => {
      this.sharedService.openModal('Message', 'There is no financial authority delegation found for you in the system.');
      this.showFields = false;
    }
  );
  }

  getdirectreport(emailAddress: string): void {
    this.permanentdelegationService.getdirectreport(emailAddress).subscribe((data: Permanentdelegation[]) => {
      this.directreport = data;
      this.processData(); 
    });
  }

  fetchMultipleData(emailAddress: string, catName: string): void {
    this.permanentdelegationService.fetchMultipleData(emailAddress, catName).subscribe((data: Permanentdelegation[]) => {
      this.data = data;
    
      this.processData();
      this.showFields = false;
    });
  }

  processData(): void {
    const groupedData: GroupedData = this.data.reduce((acc, item) => {
      if (!acc[item.typeName]) {
        acc[item.typeName] = { typeName: item.typeName, typeCode: item.typeCode, subCatCode: item.subCatCode, catCode: item.catCode, catName: item.catName, amounts: {}, Emp_No: {}, EnteredByCai: {}, EnteredDate: {}, Emailaddress: {}, showDropdown: false, dropdownData: [], selectedOption: '' };
      }
      acc[item.typeName].amounts[item.preferredName] = item.dollor || '0'; // Set default value to '0'
      acc[item.typeName].Emp_No[item.preferredName] = item.empNo;
      acc[item.typeName].EnteredByCai[item.preferredName] = item.enteredByCai;
      acc[item.typeName].EnteredDate[item.preferredName] = item.enteredDate;
      acc[item.typeName].Emailaddress[item.preferredName] = item.emailaddress;
      return acc;
    }, {} as GroupedData);

    this.directreport.forEach(report => {
      Object.keys(groupedData).forEach(typeName => {
        if (!groupedData[typeName].amounts[report.preferredName]) {
          groupedData[typeName].amounts[report.preferredName] = '0';
          groupedData[typeName].Emp_No[report.preferredName] = report.employeeNo;
          groupedData[typeName].EnteredByCai[report.preferredName] = report.enteredByCai;
          groupedData[typeName].EnteredDate[report.preferredName] = report.enteredDate;
          groupedData[typeName].Emailaddress[report.preferredName] = report.emailAddress;
        }
      });
    });

    this.processedData = Object.values(groupedData);
    this.filteredData = this.processedData;
    this.dataSource.data = this.filteredData;
    this.dataSource.paginator = this.paginator;
    this.uniqueCais = [...new Set([...this.data.map(item => item.preferredName), ...this.directreport.map(report => report.preferredName)])].filter(cai => cai !== this.loggeduser);
    this.displayedColumns = ['typeName', 'loggeduser', ...this.uniqueCais];
  }

  filterData(searchText: string): void {
    if (!searchText) {
      this.filteredData = this.processedData;
    } else {
      this.filteredData = this.processedData.filter(item =>
        item.typeName && item.typeName.toLowerCase().includes(searchText.toLowerCase())
      );
    }
    this.dataSource.data = this.filteredData;
  }

  onSearchInput(event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    this.filterData(inputElement.value);
  }

  onCategoryChange(): void {
    this.showFields = true;
    this.fetchMultipleData(this.emailAddress, this.selectedCategory);
  }

  onAmountClick(typecode: string, rowIndex: number, colIndex: number): void {
    this.permanentdelegationService.onAmountClick(typecode).subscribe((data: any) => {
      const sortedData = data.sort((a: any, b: any) => {
        const amountA = parseFloat(a.amount.replace(/,/g, ''));
        const amountB = parseFloat(b.amount.replace(/,/g, ''));
        return amountA - amountB;
      });

      this.data = sortedData;
      this.dropdownData = sortedData;
      const item = this.filteredData.find(item => item.typeCode === typecode);
      if (item) {
        item.dropdownData = sortedData;
        this.selectedCategory = item.catName;
      }

      if (!this.clickedCells[rowIndex]) {
        this.clickedCells[rowIndex] = {};
      }
      if (!this.clickedCells[rowIndex][colIndex]) {
        this.clickedCells[rowIndex][colIndex] = { dropdownData: sortedData, selectedOption: null };
      }
      if (!this.showDropdown[rowIndex]) {
        this.showDropdown[rowIndex] = {};
      }
      this.showDropdown[rowIndex][colIndex] = true;
    });
}
  

  onDropdownChange(rowIndex: number, colIndex: number, event: Event, item: any, preferredName: string): void {
    const selectElement = event.target as HTMLSelectElement;
    const selectedOption = selectElement.value;
    if (this.clickedCells[rowIndex] && this.clickedCells[rowIndex][colIndex]) {
      this.clickedCells[rowIndex][colIndex].selectedOption = selectedOption;
    }
    const previousAmount = (item.amounts[preferredName] || '0').replace(/,/g, '');
    const selectedAmountWithoutCommas = selectedOption.replace(/,/g, '');
    if (selectedAmountWithoutCommas === previousAmount) {
      this.sharedService.openModal('Message', `You have selected the same amount: ${previousAmount}`);
      return;
    }

    this.updatedRow = { ...item, selectedAmount: selectedOption, preferredName: preferredName };
 
    const existingIndex = this.selectedRowData.findIndex(row => row.typeCode === item.typeCode && row.preferredName === preferredName);
    if (existingIndex !== -1) {
      this.selectedRowData[existingIndex] = this.updatedRow;
    } else {
      this.selectedRowData.push(this.updatedRow);
    }
    this.checkAnyAmountSelected();
  }

  checkAnyAmountSelected(): void {
    this.anyAmountSelected = this.selectedRowData.some(item => item.selectedAmount);
  }

  onClick(): void {
    const dataToPass = {
      selectedCategory: this.selectedCategory,
      filteredData: this.selectedRowData
    };
   
    this.dataservice.setData(dataToPass);
    this.router.navigate(['PermanentDelegation/home/delegation/singledelegation/reviewscreen'], { state: { data1: this.loggeduserdetails } });
  }
}
